import React from 'react';
import { InputField } from 'forms/fields';
import { Row, Col, Text } from 'mymoria-ui/components';
import { form } from 'data';
import StyledCard from 'components/StyledCard';

const OfferNumber = () => (
  <StyledCard title={form.offerNumber.title}>
    <Row flexWrap="wrap">
      <Text>{form.offerNumber.explanation}</Text>
      <Col width={[1, 1, 1 / 2]} p={'0 !important'}>
        <InputField label={form.offerNumber.hint} name="offerNumber" />
      </Col>
    </Row>
  </StyledCard>
);

export default OfferNumber;
